import { Controller } from "@hotwired/stimulus"

// Switches the price field labels between the default and the "per day" variants
// depending on the selected listing type (for_rent shows daily prices), and hides
// the price fields for a donation (for_free), which has no price.
export default class extends Controller {
  static targets = ["prices", "priceField", "reducedPriceField"]
  static values = { default: String, rent: String, reducedDefault: String, reducedRent: String }

  update(event) {
    const rent = event.target.value === "for_rent"
    this.pricesTarget.hidden = event.target.value === "for_free"
    this.swap(this.priceFieldTarget, rent ? this.rentValue : this.defaultValue)
    this.swap(this.reducedPriceFieldTarget, rent ? this.reducedRentValue : this.reducedDefaultValue)
  }

  swap(field, text) {
    const textNode = field.querySelector("label")?.firstChild
    if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return

    textNode.textContent = text
  }
}
